import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { LoaderComponent } from './layouts/loader/loader.component';
import { LoginComponent } from './layouts/login/login.component';
import { AuthService, IconService } from '@services';

@Component({
  selector: 'app-root',
  imports: [MainLayoutComponent, MatSelectModule, MatButtonModule, LoaderComponent, LoginComponent, CommonModule],
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {
  isLoggedIn$ : Observable<boolean>;

  constructor(private authService: AuthService, _icons: IconService) {
    this.isLoggedIn$ = authService.isAuthenticated();
  }

  ngOnInit() {
    window.addEventListener('dragover', (e) => {
      e.preventDefault();
    });

    window.addEventListener('drop', (e) => {
      e.preventDefault();
    });
  }

}
